var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "p-4 border-b border-primary-color rounded-md rounded-b-none sm:px-6 sm:flex justify-between w-full",
    },
    [
      _c(
        "div",
        { staticClass: "w-full sm:flex items-center" },
        [
          _c(
            "div",
            { staticClass: "flex items-center sm:w-7/12 w-full" },
            [
              _c("StatusChip", {
                staticClass: "mr-4",
                attrs: { status: _vm.ChipStatus.INFO },
              }),
              _c(
                "p",
                {
                  staticClass:
                    "truncate flex-grow font-bold text-lg mr-4 cursor-default w-48",
                  class: _vm.onlyParticipantLeftStyle,
                },
                [_vm._v(" " + _vm._s(_vm.conversationTitle) + " ")]
              ),
              _vm.isGroupConversation
                ? _c("ExpandDownArrow", {
                    staticClass:
                      "h-6 w-6 mt-0.5 cursor-pointer flex-shrink-0 hover:text-primary-500",
                    nativeOn: {
                      click: function ($event) {
                        return _vm.openDetailsModal.apply(null, arguments)
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm.isGroupConversation
            ? _c(
                "div",
                { staticClass: "flex ml-auto" },
                [
                  _vm._l(
                    _vm.participantsForCircles,
                    function (participant, index) {
                      return _c("CircleWithInitials", {
                        key: index,
                        staticClass: "-mr-1 flex",
                        class: _vm.deletedParticipantCircleStyle(participant),
                        attrs: {
                          title: participant.initial,
                          avatar: participant.avatar,
                          customClass: "border border-1 border-white",
                          tooltipPlacement: _vm.tooltipPlacement.LEFT,
                          showTooltip: "",
                          primary: "",
                        },
                      })
                    }
                  ),
                  _vm.participantsRest
                    ? _c("CircleWithInitials", {
                        staticClass: "-mr-1 flex",
                        attrs: {
                          title: _vm.participantsRest,
                          customClass: "border border-white",
                          background: "#6b7280",
                          cursorPointer: "",
                        },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.openDetailsModal.apply(null, arguments)
                          },
                        },
                      })
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
          !_vm.isGroupConversation
            ? _c("UiButton", {
                staticClass: "flex-shrink-0 ml-auto",
                attrs: {
                  variant: "secondary",
                  buttonText: "Leave Conversation",
                },
                on: { click: _vm.leaveConversation },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("ConversationDetailsModal", {
        attrs: {
          conversationName: _vm.conversationTitle,
          participants: _vm.participants,
        },
        on: { leaveConversation: _vm.leaveConversation },
        model: {
          value: _vm.conversationDetailsModal,
          callback: function ($$v) {
            _vm.conversationDetailsModal = $$v
          },
          expression: "conversationDetailsModal",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }